<template>
    <section class="c-login-page c-stretch-page u-flex-set u-flex--content-center u-flex--align-items-center">
        <div v-if="!emailConfirmed || accountActivated">
            <div class="o-page-row--medium u-text-align-center"><router-link to="/"><img class="[ c-logo ]" src="@/assets/images/logo.png" width="170px" height="79px"/></router-link></div>

                <h1 class="u-text-align-center">{{ $t('customer.account.register.create_account') }}</h1>
                <p v-if="!emailConfirmed">{{ $t('global.something_went_wrong') }}</p>
                <p v-if="accountActivated">{{ $t('global.account_already_activated') }}</p>
        </div>
        <div v-if="emailConfirmed && !accountActivated">
            <form action="" class="c-form c-form--horizontal">

                <div class="o-page-row--medium u-text-align-center"><router-link to="/"><img class="[ c-logo ]" src="@/assets/images/logo.png" width="170px" height="79px"/></router-link></div>

                <h1 class="u-text-align-center">{{ $t('customer.account.register.create_account') }}</h1>
                <p>{{ $t('customer.account.register.thanks_for_registration') }}</p>

                <v-form-row>
                    <v-input v-model="user.firstName" name="firstName" :fluid="true" :error="Validate.FirstName">
                        <slot slot="label">{{ $t('customer.account.register.first_name') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="user.lastName" name="lastName" :fluid="true" :error="Validate.LastName">
                        <slot slot="label">{{ $t('customer.account.register.last_name') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-custom-select v-model="selectedFunction" 
                                     name="function" 
                                     :options="FunctionOptions" 
                                     :fluid="true" 
                                     option-name="content" 
                                     option-value="value"
                                     track-by="value"
                                     search-label="content"
                                     :error="Validate.Function">
                            <slot slot="label">{{ $t('customer.account.edit.form.personal.function.label') }}</slot>
                    </v-custom-select>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="user.phoneNumber" name="phoneNumber" :fluid="true" :error="Validate.PhoneNumber">
                        <slot slot="label">{{ $t('customer.account.register.phone_number') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="user.password" type="password" name="password" :fluid="true" :error="Validate.Password">
                        <slot slot="label">{{ $t('customer.account.register.password') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="user.confirm_password" type="password" name="confirmPassword" :fluid="true" :error="Validate.ConfirmPassword">
                        <slot slot="label">{{ $t('customer.account.register.confirm_password') }}</slot>
                    </v-input>
                </v-form-row>

                <div class="c-form-row">
                <div class="c-form-item c-form-item--horizontal c-form-item--fluid">
                    <label class="c-label"></label>
                    <div class="u-inline-block u-pos-relative u-fullwidth">
                        <p class="u-font-small">{{ $t('customer.account.register.password_minimum_length') }}</p>
                    </div>    
                </div>
                </div>
                
                <v-form-row>
                    <div class="c-form-item">
                        <button @click="submitForm" class="c-button c-button--alpha">{{ $t('customer.account.register.submit') }}</button>
                    </div>
                </v-form-row>
            </form>
        </div>
    </section>
</template>

<script>

    // Forms
    import VInput from '@/components/form/Input'
    import VFormRow from '@/components/form/Row'
    import VCustomSelect from '@/components/form/CustomSelect'

    export default {
        components: {
            VInput,
            VFormRow,
            VCustomSelect
        },
        data() {
            return {
                accountActivated: false,
                emailConfirmed: false,
                user: {
                    firstName: '',
                    lastName: '',
                    function: null,
                    phoneNumber: '',                    
                    password: '',
                    confirm_password: ''
                },
                Validate: {},
                FunctionOptions: [
                    {
                        value: 0,
                        content:this.$t('global.purchase')
                    },
                    {
                        value: 1,
                        content: this.$t('global.marketing')
                    },
                    {
                        value: 2,
                        content:this.$t('global.director')
                    },
                    {
                        value: 3,
                        content: this.$t('global.shop_assistant')
                    },
                    {
                        value: 4,
                        content:this.$t('global.accountancy')
                    }
                ]
            }
        },
        beforeCreate(){            
            this.$store.dispatch('confirmEmail',{
               userId: this.$route.query.userId,
               code: this.$route.query.code
            }).then(result => {
                if(result.Actived)
                {
                    this.accountActivated = true;
                }
                this.emailConfirmed = true;
            });
        },
        computed: {
            selectedFunction: {
                get () {
                    let output;
                    output = this.FunctionOptions.find((obj) => {
                        return obj.value === this.user.function;
                    });

                    if (output) {
                        this.$set(this.user, 'function', output.value);
                    }

                    return output ? output : { };
                },
                set (value) {
                    this.$set(this.user, 'function', value.value);
                    return value;
                }
            },
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;
                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });
                this.Validate = errors;
            },
            submitForm(e) {                
                this.$store.dispatch('register', {
                    userId : this.$route.query.userId,
                    body: {
                        firstName: this.user.firstName,
                        lastName: this.user.lastName,
                        function: this.user.function,
                        phoneNumber: this.user.phoneNumber,
                        password: this.user.password,
                        confirmPassword: this.user.confirm_password
                    }
                }).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.$router.push("/login");
                    }
                });
                e.preventDefault();
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";

    .c-login-page {
        background-color: white;
    }

    .c-login-block {
        width: 100%;
        max-width: em(400px);
    }
</style>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-stretch-page {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/common/Register.vue